module.exports = __webpack_public_path__ + "img/orthotic-dress.48091843.png";